import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export interface HiddenStyledInputProps {
  disabled?: boolean;
  readOnly?: boolean;
  $width: number;
}

export const $HiddenInput = styled.input<HiddenStyledInputProps>`
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.mainTextColor};
  width: ${({ $width }) => `${$width}px`};
  padding: 0;
  margin: 0;
  min-width: 0;
  font: inherit;
  line-height: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.colors.paragraphTextColor};
  }

  &:disabled,
  &[readonly] {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.paragraphTextColor};
  }

  height: ${spacing('lg')};
`;

export const $HiddenInputContainer = styled.div`
  min-width: 0;
  min-height: 0;
  padding: 0;
  margin: 0;
  height: ${spacing('lg')};
  display: none;
`;

export const $HiddenDiv = styled.div`
  white-space: preserve;
  visibility: hidden;
  height: 0;
`;
